/**
 * Constants the client shares with the server (TUTORIAL-STATE-001).
 *
 * MAX_OFFERS is duplicated from `apps/api/src/services/tutorial/
 * tutorialService.ts` and that is worth a note, because the obvious fix — put
 * it in `@jeanieiq/types` — would be wrong here.
 *
 * The SERVER's copy is the rule: it decides `shouldOffer`, and the client never
 * computes that itself. The client's copy is used for one cosmetic thing only —
 * whether the invitation's note says "we will ask once more" or "this is the
 * last time". If the two ever drift, the wrong note appears under the buttons
 * and nothing else changes: nobody is offered a tour they should not have, and
 * nobody is denied one.
 *
 * A shared package for a number whose worst failure is one sentence of copy
 * would put a build-order dependency between the API and the web app for no
 * safety at all — see `types-dist-vs-source`: a new export in
 * `packages/types` type-checks and passes every test while the running app
 * crashes on it.
 */

/** Keep in step with MAX_OFFERS in tutorialService.ts. Cosmetic here. */
export const MAX_OFFERS = 2;
